import * as React from "react";
import type { SVGProps } from "react";
const SvgTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M10 2.4a1 1 0 1 0-2 0h2M8 21.6a1 1 0 1 0 2 0H8M6 2.4v1h12v-2H6zM21.6 6h-1v12h2V6zM18 21.6v-1H6v2h12zM2.4 18h1V6h-2v12zM6 21.6v-1A2.6 2.6 0 0 1 3.4 18h-2A4.6 4.6 0 0 0 6 22.6zM21.6 18h-1a2.6 2.6 0 0 1-2.6 2.6v2a4.6 4.6 0 0 0 4.6-4.6zM18 2.4v1A2.6 2.6 0 0 1 20.6 6h2A4.6 4.6 0 0 0 18 1.4zm-12 0v-1A4.6 4.6 0 0 0 1.4 6h2A2.6 2.6 0 0 1 6 3.4zm3 0H8v19.2h2V2.4zM3 9v1h18V8H3z"
    />
  </svg>
);
export default SvgTable;
